import DependencyContainer from '@/presentation/configuration/DependencyContainer.ts'
import { ReferentialRepository } from '@/core/infrastructure/repositories/referential/ReferentialRepository.ts'
import { LearningModuleRepository } from '@/core/infrastructure/repositories/learning/module/LearningModuleRepository.ts'
import { ModuleBase } from '@/presentation/configuration/modules/ModuleBase.ts'
import { FetchNabooContentUseCase } from '@/core/useCases/content/FetchNabooContentUseCase.ts'
import { LearningCourseRepository } from '@/core/infrastructure/repositories/learning/course/LearningCourseRepository.ts'
import { FetchNabooContentModuleUseCase } from '@/core/useCases/content/FetchNabooContentModuleUseCase.ts'

export class ContentModule extends ModuleBase {
  initialize() {
    const referentialRepository = DependencyContainer.resolve(ReferentialRepository)
    const learningCourseRepository = DependencyContainer.resolve(LearningCourseRepository)
    const learningModuleRepository = DependencyContainer.resolve(LearningModuleRepository)

    const fetchNabooContentUseCase = new FetchNabooContentUseCase(
      learningCourseRepository,
      referentialRepository
    )
    const fetchNabooContentModuleUseCase = new FetchNabooContentModuleUseCase(
      learningModuleRepository
    )

    this.registerUseCase(FetchNabooContentUseCase, fetchNabooContentUseCase)
    this.registerUseCase(FetchNabooContentModuleUseCase, fetchNabooContentModuleUseCase)
  }
}
